import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestStatusSelector } from '../store/selectors/requests';
import { ERROR } from '../constants/toastType';
import { createToast } from '../store/actions/toast';

export default function useFetchAction(fetchAction) {
  const [requestId, setRequestId] = useState(null);
  const status = useSelector(requestStatusSelector(requestId));
  const dispatch = useDispatch();

  const fetchCallback = useCallback(
    (...args) => {
      const action = fetchAction(...args);
      setRequestId(action.meta.requestId);
      dispatch(action);
    },
    [fetchAction],
  );

  if (status?.error?.message) {
    createToast(ERROR, status?.error?.message);
  }

  return [
    fetchCallback,
    status?.status === 'pending',
    status?.error,
    status?.payload,
    status?.status,
    () => setRequestId(null),
  ];
}
